import type { AddToBasketMutation, Product } from '@packages/gql/generated/shopping/graphql';

/**
 * Returns the line item whose product matches the given SKU.
 *
 * @param lineItems The basket line items to search.
 * @param sku The product SKU to match.
 * @returns The matching line item or undefined when no item matches the SKU.
 */

export const getProductFromLineItemsBySku = (
  lineItems: AddToBasketMutation['addToBasket']['lineItems'],
  sku: Product['sku'],
): AddToBasketMutation['addToBasket']['lineItems'][number] | undefined => {
  // usually the last added line item is the one we're looking for, so check it first
  const lastLineItem = lineItems.at(-1);

  if (lastLineItem?.product.sku === sku) {
    return lastLineItem;
  }
  // but it could be that the item was merged with an existing item earlier in the list
  // so we need to find this by iterating through the line items and checking each one
  const matchingLineItem = lineItems.find((lineItem) => lineItem.product.sku === sku);

  return matchingLineItem;
};
